import {Component, inject} from '@angular/core';
import {DxTabsModule} from 'devextreme-angular';
import {AccessType, AuthService, PermissionType} from '@services';
import {OrderPlanningMixComponent} from './order-planning-mix/order-planning-mix.component';
import {PreProductionOrdersComponent} from './pre-production-orders/pre-production-orders.component';
import {PostProductionMdtComponent} from './post-production-mdt/post-production-mdt.component';

enum TabType {
    OrderPlanningMix = 'OrderPlanningMix',
    PreProductionOrders = 'PreProductionOrders',
    PostProductionMdt = 'PostProductionMdt',
}

@Component({
    selector: 'app-outbound-my-score',
    imports: [DxTabsModule, OrderPlanningMixComponent, PreProductionOrdersComponent, PostProductionMdtComponent],
    templateUrl: './my-score.component.html',
})
export class OutboundMyScoreComponent {
    private auth = inject(AuthService);

    protected readonly TabType = TabType;

    protected readonly canViewOrderPlanningMix =
        this.auth.checkPermission(PermissionType.MyScoreOrderPlanningMix, AccessType.ViewOnly);

    protected readonly canViewPreProductionOrders =
        this.auth.checkPermission(PermissionType.MyScorePreProductionOrders, AccessType.ViewOnly);

    protected readonly canViewPostProductionMdt =
        this.auth.checkPermission(PermissionType.MyScorePostProductionMdt, AccessType.ViewOnly);

    protected readonly tabs = [
        ...(this.canViewOrderPlanningMix ? [{type: TabType.OrderPlanningMix, text: 'Order Planning Mix'}] : []),
        ...(this.canViewPreProductionOrders ? [{type: TabType.PreProductionOrders, text: 'Pre-Production Orders'}] : []),
        ...(this.canViewPostProductionMdt ? [{type: TabType.PostProductionMdt, text: 'Post-Production MDT'}] : []),
    ];

    protected selectedTab: TabType | undefined = this.tabs[0]?.type;

    protected onTabClick(type: TabType): void {
        this.selectedTab = type;
    }
}
